import React, { useState, useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';
import './SplashScreen.css';

const SplashScreen = () => {
    const { settings } = useSettings();
    // Starting directly with true so it's visible on mount
    const [isVisible, setIsVisible] = useState(true);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        // Play on every refresh as requested

        // Duration to stay fully opaque
        const displayTime = 3000;

        // Timer for start fading
        const fadeTimer = setTimeout(() => {
            setIsVisible(false);
        }, displayTime);

        // Timer for complete removal from DOM
        const removeTimer = setTimeout(() => {
            setShouldRender(false);
        }, displayTime + 1000);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, []);

    if (!shouldRender) return null;

    return (
        <div className={`splash-screen ${!isVisible ? 'fade-out' : ''}`}>
            <div className="splash-logo-container">
                <img
                    src={settings.siteLogo || "/images/logo_real.jpg"}
                    alt={settings.siteName}
                    className="splash-logo"
                />
                <h1 className="splash-text">{settings.siteName}</h1>
                <p className="splash-subtitle">{settings.siteSlogan}</p>
            </div>
        </div>
    );
};

export default SplashScreen;
